import React from "react";

const DefaultCurrencyFormat = ({ value, Symbol }) => {
  // Map of currency symbols to their ISO codes
  const symbolToCode = {
    "₺": "TRY",
    $: "USD",
    "€": "EUR",
    "£": "GBP",
  };

  // If Symbol is not in our map or undefined, default to TRY
  const currencyCode = symbolToCode[Symbol] || "TRY";

  try {
    const formattedValue = new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 0,
    }).format(value);

    return <>{formattedValue}</>;
  } catch (error) {
    return (
      <>
        {Symbol}
        {value}
      </>
    );
  }
};

export default DefaultCurrencyFormat;